import { FIAT_ORDER } from '@exodus/models'
import { createSelector } from 'reselect'

const selectorFactory = (visibleOrdersSelector, hiddenFailedFiatOrderNotificationsSelector) =>
  createSelector(
    visibleOrdersSelector,
    hiddenFailedFiatOrderNotificationsSelector,
    (fiatOrders, hiddenOrderIds) => {
      const lastOrder = [...fiatOrders].pop()

      if (!lastOrder) {
        return null
      }

      const orderId = lastOrder.orderId

      if (hiddenOrderIds[orderId]) {
        return null
      }

      const exodusStatus = lastOrder.exodusStatus

      if (exodusStatus === FIAT_ORDER.ORDER_STATUS.failed) {
        return lastOrder
      }

      return null
    }
  )

const lastFailedOrderSelectorDefinition = {
  id: 'lastFailedOrder',
  selectorFactory,
  dependencies: [{ selector: 'visibleOrders' }, { selector: 'hiddenFailedFiatOrderNotifications' }],
}

export default lastFailedOrderSelectorDefinition
